<template>
  <div v-if="questionsInfo">
    <div v-if="currentQuestionIndex < 0 || currentQuestionIndex >= questionsInfo.length" id="waiting-page">
      <video autoplay muted loop>
        <source src="../assets/media/idle.mp4" type="video/mp4">
        Your browser does not support the video tag.
      </video>
    </div>
    <div v-else-if="currentQuestionIndex < questionsInfo.length && currentQuestionIndex >= 0" class="border-color-primary" id="preview-screen-specialist" :style="{backgroundColor:questionsInfo[currentQuestionIndex].background_color, position: 'relative'}">
      <div v-for="(image, index) in questionsInfo[currentQuestionIndex].child_images" :key="`preview-screen-image${index}`"
        :style="{
          top: `${image.y}px`,
          left: `${image.x}px`,
          width: `${image.width}px`,
          height: `${image.height}px`,
          backgroundColor: image.background_color,
          zIndex: image.zIndex,
        }"
        class="final-image-container"
      >
      <img v-if="image.fileRef" :src="`${reverseProxy}/api/${image.fileRef}`" alt="Picture N/A" width="100%" height="100%"/>
      </div>
      <div v-for="(button, index) in questionsInfo[currentQuestionIndex].child_buttons" :key="`preview-screen-button${index}`"
        :style="{
          top: `${button.y}px`,
          left: ` ${button.x}px`,
          width: `${button.width}px`,
          height: `${button.height}px`,
          backgroundColor: button.background_color,
          zIndex: button.zIndex,
          fontSize: `${button.fontSize}px`,
        }"
        class="final-button-container"
      >
        <img v-if="button.fileRef" :src="`${reverseProxy}/api/${button.fileRef}`" alt="Picture N/A" width="100%" height="100%"/>
        <div class="placeholder-rect">{{ button.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
  import instance from '../axios.js';

  export default {
    data() {
      return {
        reverseProxy: process.env.VUE_APP_REVERSE_PROXY_ENDPOINT,
        activityData: null,
        purchaseData: null,
        applicationInfo: null,
        questionsInfo: null,
        questionResultData: null,
        activityID: null,
        currentQuestionIndex: -1,
        channel: null,
      }
    },
    async created() {
      function placeInArray(arr, value, variableToCheck, findOrder) {
        let low = 0;
        let high = arr.length - 1;
        // Binary search to find the insertion point
        while (low <= high) {
          const mid = Math.floor((low + high) / 2);
          if (arr[mid][variableToCheck] < findOrder) {
            low = mid + 1;
          } else {
            high = mid - 1;
          }
        }

        // If the value is not in the array, insert it at the correct position
        arr.splice(low, 0, value);
        return arr;
      }
      try {
        let activityData = await instance.get(`/api/activity/${this.$route.params.activityID}`);
        this.activityData = activityData.data;
        let purchaseData = await instance.get(`/api/user-app-purchased-junction/${this.activityData.purchase_id}`);
        this.purchaseData = purchaseData.data;
        let applicationResponse = await instance.get(`/api/appAdmin/application/${this.purchaseData.application_id}`);
        this.applicationInfo = applicationResponse.data;
        let questionsResponse = await instance.get(`/api/question-admin/application/${this.applicationInfo.application_id}`);
        let questionResponse = questionsResponse.data;
        let questionResultResponse = await instance.get(`/api/question-result/activity/${this.$route.params.activityID}`);
        this.questionResultData = questionResultResponse.data;

        let result = [];
        for (let i = 0; i < questionResponse.length; i++) {
          placeInArray(result, {
            ...questionResponse[i],
            child_buttons: JSON.parse(questionResponse[i].child_buttons),
            specialist_buttons: JSON.parse(questionResponse[i].specialist_buttons),
            child_images: JSON.parse(questionResponse[i].child_images),
            time_out: parseInt(questionResponse[i].time_out),
            typical_duration: parseInt(questionResponse[i].typical_duration),
          }, 'question_order', questionResponse[i].question_order);
        }
        this.activityID = this.$route.params.activityID;
        
        const resultLookup = this.questionResultData.reduce((acc, qr) => {
          acc[qr.question_reference_id] = qr;
          return acc;
        }, {});
        const nestedQuestions = result.map((question) => ({
          ...question,
          questionResult: resultLookup[question.question_id] || null,
        }));
        this.questionsInfo = nestedQuestions;

        if (questionResponse.length > 0) {
          this.formatForNewResolution('preview-screen-specialist');
        }

        this.setUpBroadCast();
      } catch (e) {
        console.error(e);
      }
    },
    methods: {
      getImageFileSrc(imageDetailObject) {
        if (imageDetailObject.fileRef != null && imageDetailObject.fileRef != "") {
          return imageDetailObject.fileRef;
        } else if (imageDetailObject.file != null) {
          return URL.createObjectURL(imageDetailObject.file);
        } else {
          return null;
        }
      },
      formatForNewResolution(elementID) {
        this.$nextTick(() => {
          if (!document.getElementById(elementID)) {
            return;
          }

          let currentQuestionInstance = this.questionsInfo[this.currentQuestionIndex];
          let [originalWidth, originalHeight] = currentQuestionInstance.child_view_original_screen_resolution.split('x').map(Number);
          let newWidth = document.getElementById(elementID).offsetWidth;
          let newHeight = document.getElementById(elementID).offsetHeight;
          if (newWidth == originalWidth && newHeight == originalHeight) {
            return;
          }

          //[x,y] transform coordinates from original to new resolution
          let xTransform = newWidth / originalWidth;
          let yTransform = newHeight / originalHeight;

          for (let i = 0; i < currentQuestionInstance.child_buttons.length; i++) {
            currentQuestionInstance.child_buttons[i].x *= xTransform;
            currentQuestionInstance.child_buttons[i].y *= yTransform;
            currentQuestionInstance.child_buttons[i].height *= yTransform;
            currentQuestionInstance.child_buttons[i].width *= xTransform;
          }

          for (let i = 0; i < currentQuestionInstance.child_images.length; i++) {
            currentQuestionInstance.child_images[i].x *= xTransform;
            currentQuestionInstance.child_images[i].y *= yTransform;
            currentQuestionInstance.child_images[i].height *= yTransform;
            currentQuestionInstance.child_images[i].width *= xTransform;
          }

          currentQuestionInstance.child_view_original_screen_resolution = `${newWidth}x${newHeight}`;
        });
      },
      setUpBroadCast() {
        this.channel = new BroadcastChannel(`${this.activityID}`);

        this.channel.addEventListener('message', this.receiveChannelMessage);
      },
      receiveChannelMessage(event) {
        if (event.data.action == 'changeIndex') {
          this.currentQuestionIndex = event.data.data;
          this.formatForNewResolution('preview-screen-specialist');
        }
      },
      sendChannelMessage(message) {
        this.channel.postMessage(message);
      }
    },
    beforeDestroy() {
      this.channel.removeEventListener('message', this.sendChannelMessage);
      this.channel.close();
    }
  }
</script>

<style lang="scss" scoped>
  @use 'sharedSCSS/globalSharedVariables';
  $reportOrange: #FF9B00;
  $reportOrangeLight: #eecc9a;

  #waiting-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100dvh;

    video {
      position: fixed;
      top: 0;
      left: 0;
      width: 100dvw;
      height: 100dvh;
      object-fit: cover;
    }
  }

  .border-color-primary {
    border: solid 2px $reportOrange;
    background-color: pink;
    width: 100%;
    height: 100dvh;
    position: relative;

    > div {
      position: absolute;
    }

    .resizable-button-container, .final-button-container {
      $local-border-radius: 1rem;

      position: absolute;
      border-radius: $local-border-radius;
      box-shadow: 0 0 5px 5px lightgrey;
      border: solid black 1px;
      user-select: none;
      cursor: pointer;
      
      .placeholder-rect {
        position: absolute;
        top: 0;
        left: 0;
        word-wrap: break-word;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      img {
        border-radius: $local-border-radius;
      }
    }
  }
</style>